import './styles/index.less';
import 'typeface-lato';

import { HelmetProvider } from 'react-helmet-async'; // eslint-disable-line

import Routing from './routing';
import { useState } from 'react';
import '@monorepo/shared/i18n/config';
import { CookiesProvider } from 'react-cookie';

function App() {
  const isDarkTheme = false;
  const [darkMode, setDarkMode] = useState(isDarkTheme);
  return (
    <CookiesProvider>
      <HelmetProvider>
        <Routing darkMode={darkMode} setDarkMode={setDarkMode}></Routing>
      </HelmetProvider>
    </CookiesProvider>
  );
}

export default App;
